import { compile } from 'app/infrastructure/js/template';
import { AppSetting } from 'dependencies/appsettings';

export const urlToSurveyManager = (linkUrl: string, favouriteId?: number) => {
  const context = {
    ...(AppSetting.Integrations as any),
    ...(favouriteId && { favouriteId })
  };
  return compile(linkUrl, context);
};
